const exported = {
  DEFAULT_CHILDREN_ANSWERS_LIMIT: 2147483647,
};

export default exported;

export const { DEFAULT_CHILDREN_ANSWERS_LIMIT } = exported;
